// @ts-nocheck

// Accept either a legacy URL string or the new nested `{ id, url, ... }`
// file shape that the backend now returns on every owner endpoint. Each
// helper below first normalizes via toUrl(); callers that already pass a
// plain URL continue to work unchanged.
const toUrl = (val) => {
  if (val && typeof val === 'object' && typeof val.url === 'string') return val.url;
  return val;
};

export const userAvatar = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/40x40/images/'+imageName;
        return imageUrl;
    }
    if(typeof url === 'string' && /^https?:\/\//i.test(url)){
        return url;
    }
    return null;
}
export const userAvatar100 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/100x100/images/'+imageName;
        return imageUrl;
    }
    if(typeof url === 'string' && /^https?:\/\//i.test(url)){
        return url;
    }
    return null;
}

export const imgae200 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/200x200/images/'+imageName;
        return imageUrl;
    }
    if(typeof url === 'string' && /^https?:\/\//i.test(url)){
        // Azure SAS / arbitrary https URL — pass through.
        return url;
    }
    return null;
}
export const doc300 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/300x300/documents/'+imageName;
        return imageUrl;
    }else{
        // set default image
        return null;
    }
}
export const doc400 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/400x400/documents/'+imageName;
        return imageUrl;
    }
    if(typeof url === 'string' && /^https?:\/\//i.test(url)){
        return url;
    }
    return null;
}
export const doc600 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/600x600/documents/'+imageName;
        return imageUrl;
    }else{
        // set default image
        return null;
    }
}
export const image400 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/400x400/images/'+imageName;
        return imageUrl;
    }else{
        // set default image
        return null;
    }
}
export const image600 = (url)=>{
    url = toUrl(url);
    if(url && typeof url === 'string' && url.includes('s3')){
        let imageName = url.slice(url.lastIndexOf('/')+1, url.length);
        let imageUrl = 'https://d2zxqy2dinp2ov.cloudfront.net/fit-in/600x600/images/'+imageName;
        return imageUrl;
    }
    if(typeof url === 'string' && /^https?:\/\//i.test(url)){
        return url;
    }
    return null;
}